import { ApiError } from '../api/client';

export function ErrorBanner({ error }: { error: unknown }) {
  if (!error) {
    return null;
  }

  const message = error instanceof Error ? error.message : String(error);
  const details = error instanceof ApiError ? error.validationMessages.slice(1) : [];

  return (
    <div className="alert alert-danger d-flex gap-2" role="alert">
      <i className="pi pi-exclamation-circle mt-1" aria-hidden="true" />
      <div>
        {message}
        {details.length > 0 && (
          <ul className="mb-0 mt-1">
            {details.map((detail) => (
              <li key={detail}>{detail}</li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
}
